import { type Maybe } from '../../../utils/typings.ts';
import { type IMarginDirective } from './IMarginDirective.ts';

function normalizeMargin(value: unknown): number {
  if (typeof value === 'number' && Number.isFinite(value) && value >= 0) {
    return Math.round(value);
  }
  return 0;
}

/**
 * Genera lo stile di padding in base alla configurazione del margine directive.
 * Utilizzando il padding per evitare problemi di compatibilità con i browser.
 * @param margin
 * @returns
 */
export function generateMarginStyle(margin: Maybe<IMarginDirective>): string {
  if (!margin) return '';

  const top = normalizeMargin(margin.top);
  const right = normalizeMargin(margin.right);
  const bottom = normalizeMargin(margin.bottom);
  const left = normalizeMargin(margin.left);

  if (top === 0 && right === 0 && bottom === 0 && left === 0) return '';

  return `padding: ${top}px ${right}px ${bottom}px ${left}px;`;
}

export function wrapWithMarginStyleDiv(
  html: string,
  margin: Maybe<IMarginDirective>,
): string {
  const marginStyle = generateMarginStyle(margin);
  if (marginStyle) {
    return `<div style="${marginStyle}">${html}</div>`;
  }
  return html;
}
